// extracted by mini-css-extract-plugin
module.exports = {"credentialsContainer":"main_credentialsContainer__2Fbch","boxContainer":"main_boxContainer__KetKN","errorsBlock":"main_errorsBlock__1YRIO"};